var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_1874)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "#002A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3C11.2607 3.0002 13.2462 5.13803 14.2324 6.625C14.4891 7.0121 14.6277 7.44688 14.6514 7.88574C13.8122 7.23899 12.5217 7.40858 11.9248 8.40234V8.40332L9.76562 12.0039C9.60436 12.2729 9.51911 12.5581 9.50098 12.8398C9.03396 12.9414 8.5343 13 8 13C4.7467 12.9998 2.76387 10.8932 1.77539 9.42188C1.20262 8.56929 1.19995 7.481 1.76758 6.625C2.75371 5.13802 4.73913 3.00021 8 3ZM8 5C6.3433 5.00018 5 6.34326 5 8C5 9.65674 6.3433 10.9998 8 11C9.65679 10.9999 11 9.6568 11 8C11 6.3432 9.65679 5.00008 8 5Z",
    fill: "#002A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.211 9.17466C13.3508 8.94174 13.6883 8.94181 13.8282 9.17466L15.9884 12.7753C16.1323 13.0152 15.9586 13.3211 15.6788 13.3211H11.3604C11.0806 13.3211 10.9079 13.0152 11.0518 12.7753L13.211 9.17466ZM13.5177 11.9628C13.3854 11.963 13.2785 12.0674 13.2784 12.1961C13.2784 12.325 13.3853 12.4293 13.5177 12.4295C13.6502 12.4295 13.7579 12.3252 13.7579 12.1961C13.7578 12.0672 13.6502 11.9628 13.5177 11.9628ZM13.5186 10.328C13.325 10.328 13.173 10.4935 13.1895 10.6864L13.2579 11.4901C13.2695 11.6253 13.3829 11.7294 13.5186 11.7294C13.6543 11.7293 13.7678 11.6253 13.7794 11.4901L13.8477 10.6864C13.8643 10.4935 13.7122 10.328 13.5186 10.328Z",
    fill: "#002A69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_1874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionRequired);
export default __webpack_public_path__ + "static/media/Attention_required.ec04c3e76d9ae0f8dfcef84697d955b1.svg";
export { ForwardRef as ReactComponent };